import React from 'react';
/**
 * Shows the active context as small chips so the user can see what the
 * assistant is scoped to. To add a new context bit, add a field to
 * `AssistantContext` and a corresponding entry to `chips` below.
 */
export const ContextBar = ({ context }) => {
    const chips = [{ label: 'Job', value: context.jobId }].filter((chip) => Boolean(chip.value));
    if (chips.length === 0)
        return null;
    return (React.createElement("div", { className: "ai-assistant__context" }, chips.map((chip) => (React.createElement("span", { className: "ai-assistant__context-chip", key: chip.label },
        chip.label,
        ": ",
        chip.value)))));
};
